// import { ClassicEditor } from '@ckeditor/ckeditor5-editor-classic'
// import { CKEditor } from '@ckeditor/ckeditor5-react'
import React from 'react'
import DefaultEditor from 'react-simple-wysiwyg'

const TextEditor = () => {
    return (
        <div>
             <DefaultEditor />
    </div>
    )
}

export default TextEditor
